import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["value", "data-test"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("select", {
    class: "form-control",
    ref: "root",
    disabled: _ctx.disabled
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createElementBlock("option", {
        value: option.id,
        key: option.id,
        "data-test": `${_ctx.$props.dataTestOptions}Duration-${option.name}`
      }, _toDisplayString(option.name), 9, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}